/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize TFG Deterioration List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './TFGDeteriorationListView';

export const mapStateToPropsTFGDeteriorationList = mapStateToProps;
export const mapDispatchToPropsTFGDeteriorationList = mapDispatchToProps;

export default connect(
  mapStateToPropsTFGDeteriorationList,
  mapDispatchToPropsTFGDeteriorationList
)(View);
